export default class Tab {
  constructor() {
    let tabs = document.querySelectorAll(".cb-tab");

    tabs.forEach(tab => {
      this.initiate(tab);
    });
  }

  initiate(tab) {
    tab.querySelector(".tab-header").addEventListener("click", event => {
      let target = event.target;

      if (target.nodeName === "LI" && target.hasAttribute("data-target")) {
        tab.querySelectorAll(".tab-content").forEach(content => {
          content.classList.remove("active");
        });

        tab.querySelectorAll("ul li").forEach(item => {
          item.classList.remove("active");
        });

        tab
          .querySelector(target.getAttribute("data-target"))
          .classList.add("active");
        target.classList.add("active");
      }
    });
  }
}
